import { Button, TextField } from "@mui/material";
import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { authTokenUrl, client_id, client_secret, grant_type, isDevelopmentLogin, notifyChange, scope, URLCustonView } from "../../util/env";
import { getUserToken } from "../../token/UserToken";
import qs from "qs";

export default function ChangePassword() {
    const [userName, setUserName] = useState("");
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const passwordStrongRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).+$/;
    const isPasswordStrong = passwordStrongRegex.test(newPassword);
    const isPasswordValid = userName !== "" && oldPassword !== "" && newPassword !== "" && newPassword === confirmPassword && isPasswordStrong;
    const navigate = useNavigate();

    const urlChangePassword = (userId: string) => isDevelopmentLogin() ? `https://nazaria-dev.homologacao.cosmospro.com.br/odata/central/odata/User(${userId})/AlterPassword` :  `https://nazaria.cosmospro.com.br/odata/central/odata/User(${userId})/AlterPassword`;

    function handleChangePassword(e: any) {
        e.preventDefault();
        setLoading(true);
        let data = qs.stringify({
                'grant_type': grant_type,
                'username': userName,
                'password': oldPassword,
                'scope': scope,
                'client_id': client_id,
                'client_secret': client_secret
            });
            let config = {
                method: 'post',
                // maxBodyLength: Infinity,
                url: authTokenUrl(),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                data: data
            };
    
            axios.request(config)
                .then((response: any) => {
                    console.log("login", response);
                    const userId = getUserToken(response.data.access_token).sub;  
                    console.log("userId", userId); 
                    
                    return axios.post(urlChangePassword(userId), {   
                        "SENHA": newPassword
                    }, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${response.data.access_token}`
                        }
                    }).then(() => {
                        alert("Senha alterada com sucesso!");
                        navigate("/login");
                    })
                    .catch(() => {
                        alert("Erro ao alterar senha.");
                    })
                    .finally(() => setLoading(false));;
                })
                .catch((error: any) => {
                    if (error.response?.data?.error === "invalid_grant")
                        notifyChange("Usuário ou senha invalido", "error")
                    else
                        notifyChange("Não foi possivel realizar o acesso", "error")
                    console.log("error", error);
                })
                .finally(() => setLoading(false));
    }

    return (
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div className="view" style={{ width: '100%', maxWidth: 550 }}>
                <h2 style={{ textAlign: 'center' }}>Alterar de Senha</h2>
                <form onSubmit={handleChangePassword} className="content-form" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <div className="field" style={{ width: '500px', maxWidth: '100%' }}>
                        <TextField
                            required
                            label="Login"
                            variant="standard"
                            fullWidth
                            onChange={e => setUserName(e.target.value)}
                            value={userName}
                        />
                    </div>
                    <div className="field" style={{ width: '500px', maxWidth: '100%' }}>
                        <TextField
                            required
                            label="Senha Atual"
                            type="password"
                            variant="standard"
                            fullWidth
                            onChange={e => setOldPassword(e.target.value)}
                            value={oldPassword}
                        />
                    </div>
                    <div className="field" style={{ width: '500px', maxWidth: '100%' }}>
                        <TextField
                            required
                            label="Nova Senha"
                            type="password"
                            variant="standard"
                            fullWidth
                            onChange={e => setNewPassword(e.target.value)}
                            value={newPassword}
                            error={newPassword !== "" && !isPasswordStrong}
                            helperText={
                                newPassword !== "" && !isPasswordStrong
                                    ? "A senha deve conter pelo menos uma letra maiúscula, uma minúscula, um número e um caractere especial."
                                    : ""
                            }
                        />
                    </div>
                    <div className="field" style={{ width: '500px', maxWidth: '100%' }}>
                        <TextField
                            required
                            label="Confirme a Nova Senha"
                            type="password"
                            variant="standard"
                            fullWidth
                            onChange={e => setConfirmPassword(e.target.value)}
                            value={confirmPassword}
                            error={confirmPassword !== "" && confirmPassword !== newPassword}
                            helperText={
                                confirmPassword !== "" && confirmPassword !== newPassword
                                    ? "As senhas precisam ser iguais."
                                    : ""
                            }
                        />
                    </div>
                    <div className="field" style={{ width: '500px', maxWidth: '100%' }}>
                        <Button variant="contained" type="submit" fullWidth disabled={loading || !isPasswordValid}>Alterar Senha</Button>
                    </div>
                    <div className="field" style={{ width: '500px', maxWidth: '100%' }}>
                        <Button variant="text" onClick={() => navigate("/login")} fullWidth disabled={loading}>
                            Voltar para Login
                        </Button>
                    </div>
                </form>
            </div>
        </div>
    );
}
